import * as React from "react";
import { Menu } from "antd";
const SubMenu = Menu.SubMenu;
import { Link } from "react-router-dom";
// import { connect } from "react-redux";
import { DisplayProperty } from "csstype";
// import { browserHistory } from "react-router";

// const IconFont = Icon.createFromIconfontCN({
//   scriptUrl: "//at.alicdn.com/t/font_776204_s2zmsrn535k.js"
// });

interface IMenuData {
  title: string;
  url?: string;
}

interface ISysMenu {
  // 菜单的样式
  style?: any;
  // 菜单数据
  menuData: Array<IMenuData>;
  // 菜单数据
  sysMenu: Array<IMenuData>;
  // 获取系统菜单
  getSysMenu: any;
  // 收缩状态
  collapsed?: any;
  // 更新系统状态
  updateSysMenuStatus: any;
  // 系统菜单状态
  sysMenuStatus: any;
  // 临时的菜单选中方案
  isTemporary?: any;
}

// 系统菜单
class SysMenu extends React.Component<ISysMenu, any> {
  state = { isOpen: false };

  constructor(props: ISysMenu) {
    super(props);
  }

  componentDidMount() {
    this.props.getSysMenu();

    // 获取选中状态
    //console.log("routerInfo", this.props.params);
  }

  handleClick = e => {
    console.log("click ", e);
  };

  // 拦截
  intercept = (item, index) => {
    let isIntercept = false,
      element: any;
    switch (item.title) {
      case "首页":
        element = <Menu.Item key={item.title}>{item.title}</Menu.Item>;
        isIntercept = true;
        break;
      default:
        break;
    }
    return [isIntercept, element];
  };

  // 添加测试代码
  addTestCode = title => {
    let menuList: any = [];
    const menuInfo: any = [
      {
        title: "重构：子订单列表",
        path: "/app/orderList/1"
      },
      {
        title: "重构：天猫海外店",
        path: "/app/orderList/2"
      },
      {
        title: "重构：分公司天猫店",
        path: "/app/orderList/3"
      },
      {
        title: "重构：天猫丽江店",
        path: "/app/orderList/4"
      },
      {
        title: "重构：商城",
        path: "/app/orderList/5"
      }
    ];
    if (title != "订单管理") {
      return [];
    }
    for (const item of menuInfo) {
      menuList.push(
        <Menu.Item key={item.title}>
          <Link to={{ pathname: item.path, search: "?" + item.params }}>
            {item.title}
          </Link>
        </Menu.Item>
      );
    }

    return menuList;
  };

  // 获取图标
  getIcon = recard => {
    return (
      <div style={this.titleContainerStyle}>
        <span>
          <i className={"action-user " + (recard.icon || "action-order")} />
          <span style={this.textStyle}>{recard.title}</span>
        </span>
      </div>
    );
  };

  textStyle = {};

  titleContainerStyle = {};

  shouldComponentUpdate(nextProps, nextState) {
    // if (
    //   (this.props.collapsed == true && nextProps.collapsed == true) ||
    //   (this.props.collapsed == false && nextProps.collapsed == false)
    // ) {
    //   if (this.props.sysMenu.length == nextProps.sysMenu.length) {
    //     return false;
    //   }
    // }

    if (nextProps.collapsed) {
      this.textStyle = {
        marginLeft: "6px",
        fontSize: "16px",
        display: "none" as DisplayProperty
      };

      this.titleContainerStyle = {
        width: "100%",
        fontSize: "14px",
        display: "flex" as DisplayProperty,
        alignItems: "center",
        flexDirection: "column"
      };
    } else {
      this.textStyle = {
        marginLeft: "6px"
      };

      this.titleContainerStyle = {};
    }
    //return true;
    //}

    return true;
  }

  count = 0;

  // 为了选中菜单项，临时处理方案
  setMkeyAndOpenKey = (title, original, level = 1) => {
   // console.log(title, original);
    if (this.props.isTemporary) {
      // 一级菜单
      if (level == 1) {
        if (title == "订单管理") {
          return "999";
        }
      } else if (level == 2) {
        switch (title) {
          case "天猫丽江店":
            return "999_5";
          case "分公司天猫店":
            return "999_4";
          case "天猫海外店":
            return "999_3";
          case "子订单列表":
            return "999_1";
          case "新子订单列表":
            return "999_1";
          default:
            return original;
        }
      } else {
        return original;
      }
    } else {
      return original;
    }
    return original;
  };

  // 计算菜单
  getMenu = (data, level = 1, parent = -1) => {
    if (!data) return [];
    //console.log("count", this.count);
    let menuList = Array<any>();
    try {
      data.forEach((item, index) => {
        if (item.title === "首页") return;
        let interceptInfo = this.intercept(item, index);
        if (interceptInfo[0]) {
          menuList.push(interceptInfo[1]);
        } else {
          this.count++;
          const key = this.setMkeyAndOpenKey(item.title, this.count, level);
          if (level == 1) {
            menuList.push(
              <SubMenu key={key} title={this.getIcon(item)}>
                {this.getMenu(item.child, 2, key)}
                {/* 注意注意  测试代码 */}
                {/* {this.addTestCode(item.title)} */}
                {/* 注意注意  测试代码 */}
              </SubMenu>
            );
          } else {
            if (item.child) {
              menuList.push(
                <SubMenu key={key} title={item.title}>
                  {this.getMenu(item.child, 2, key)}
                  {/* 注意注意  测试代码 */}
                  {/* {this.addTestCode(item.title)} */}
                  {/* 注意注意  测试代码 */}
                </SubMenu>
              );
            } else {
              const menuClick = (mkey, openKey) => {
                return data => {
                  console.log("menuClick", data, item.uri, openKey);
                  //location.href =
                  //item.uri + "?mkey=" + mkey + "&openKey=" + openKey;
                  if (this.props.isTemporary) location.href = item.uri;
                  else
                    location.href =
                      item.uri + "?mkey=" + mkey + "&openKey=" + openKey;
                };
              };

              // 携带参数的链接地址 可以使菜单选中
              //const hrefAddr = item.uri + "?mkey=" + key + "&openKey=" + parent;

              let hrefAddr = item.uri;
              if (this.props.isTemporary) hrefAddr = item.uri;
              else hrefAddr = item.uri + "?mkey=" + key + "&openKey=" + parent;

              menuList.push(
                <Menu.Item key={key} onClick={menuClick(key, parent)}>
                  {/* <a href={item.uri + "?mkey=" + this.count}> */}
                  {/* {this.count + "-" + parent + "-" + item.title} */}
                  <a href={hrefAddr}>{item.title}</a>
                  {/* </a> */}
                </Menu.Item>
              );
            }
          }
        }
      });
    } catch (error) {
      console.error(error, "接口返回的数据结构有误");
    }
    return menuList;
  };

  onOpenChange = item => {
    console.log("onOpenChange", item);
    this.setState({ isOpen: true });
    this.props.updateSysMenuStatus({
      openKeys: item
    });
  };

  onSelect = data => {
    console.log("onSelect", data.selectedKeys);
    this.props.updateSysMenuStatus({
      selectedKeys: data.selectedKeys[0]
    });
  };

  render() {
    this.count = 0;
    // 这里判断是否需要展开菜单
    // let openKeys: any = [];
    // if (this.state.isOpen || !this.props.collapsed) {
    //   openKeys = this.props.sysMenuStatus.openKeys;
    // }

    return (
      <Menu
        onOpenChange={this.onOpenChange}
        onSelect={this.onSelect}
        onClick={this.handleClick}
        style={this.props.style}
        multiple={false}
        selectedKeys={[this.props.sysMenuStatus.selectedKeys]}
        // openKeys={openKeys}
        // selectable={true}
        // {...this.state.menuKey}
        mode="inline"
        // inlineCollapsed={true}
        theme="dark"
      >
        {this.getMenu(this.props.sysMenu, 1)}
      </Menu>
    );
  }
}

export default SysMenu;

// const mapState = state => ({
//   sysMenuStatus: state.globalStatus.sysMenuMg
// });

// const mapDispatch = dispatch => ({
//   updateSysMenuStatus: dispatch.globalStatus.updateSysMenuStatus
// });

// export default connect(
//   mapState,
//   mapDispatch
// )(SysMenu);
